import axios from "axios";

import URLS from "../../util/urls";

const state = {
  listaFormularios: [],
  formularioPesquisa: { tipo: null },
  formularioSelecionado: { id: 0, perguntasFormulario: [] },
};
const mutations = {
  atualizarListaFormularios(state, payload) {
    state.listaFormularios = payload.lista;
  },
  limparFormulariosListados(state) {
    state.listaFormularios = [];
  },
  atualizarFormularioSelecionado(state, payload) {
    state.formularioSelecionado = payload;
  },
  novoFormulario(state) {
    state.formularioSelecionado = { id: 0, perguntasFormulario: [] };
  }
};
const actions = {
  listarFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_LISTAR, payload).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("listarFormularios", payload);
              }
            }).catch((error) => {
              throw error;
            });
        case "SUCESSO":
          context.commit("atualizarListaFormularios", response.data);
          return response.data;
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  limparFormulariosListados(context) {
    context.commit("limparFormulariosListados");
  },
  recuperarFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR_FORMULARIO, payload).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("recuperarFormulario", payload);
              }
            }).catch((error) => {
              throw error;
            });
        case "SUCESSO":
          context.commit("atualizarFormularioSelecionado", response.data.item);
          return response.data;
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoFormulario(context) {
    context.commit("novoFormulario");
  },
  removerFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_REMOVER, payload).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("removerFormulario", payload);
              }
            }).catch((error) => {
              throw error;
            });
        case "SUCESSO":
          context.commit("novoFormulario");
          return response.data;
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gravarFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_GRAVAR, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("gravarFormulario", payload);
              }
            }).catch((error) => {
              throw error;
            });
        case "SUCESSO":
          context.commit("atualizarFormularioSelecionado", response.data.item);
          return response.data;
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  downloadFormulario(context, payload) {
    return context.dispatch('loginStore/relogar', {}, { root: true })
      .then(authResponse => {
        if(authResponse.status == 'SUCESSO') {
          return axios.post(URLS.FORMULARIOS_DOWNLOAD, payload, { responseType: 'blob' })
            .then(response => {
              return response.data;
            }).catch(error => {
              throw error;
            });
        }
      })
      .catch(error => {
        throw error;
      });
  }
};

export default {
  state,
  mutations,
  actions
};